const mixWithWhite = (hex, amount = 0.6) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  const nr = Math.round(r + (255 - r) * amount);
  const ng = Math.round(g + (255 - g) * amount);
  const nb = Math.round(b + (255 - b) * amount);

  return `rgb(${nr}, ${ng}, ${nb})`;
};

export default function MonthGridEvent({ calendarEvent }) {
  const safeColor = calendarEvent?.data?.color || '#9CA3AF';

  return (
    <div
      title={calendarEvent.title}
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        overflow: 'hidden',
        background: safeColor,
        width: '100%'
      }}
    >
      <div
        style={{
          width: 5,
          height: '100%',
          background: mixWithWhite(safeColor, 0.6),
          flexShrink: 0
        }}
      />

      <div
        style={{
          padding: '4px 8px',
          fontSize: 12,
          fontWeight: 600,
          color: '#fff',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: '100%'
        }}
      >
        {calendarEvent.title}
      </div>
    </div>
  );
}
